module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-small-582.4bd26b3f45c27778.png"+" 582w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-small-582.4bd26b3f45c27778.png",width: 582,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-small-582.4bd26b3f45c27778.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-small-582.4bd26b3f45c27778.png"},
        
        width: 582,
        height: 400
      }